import React from 'react';
import axios from 'axios';
import { Card, Button,Form,Input,message,Spin,Select} from 'antd';
import IDTypeForm from '../components/SupplyForm'
import { UserOutlined,LoadingOutlined } from '@ant-design/icons';
import * as serverconfig from '../../serverconn'
import {
    Col,
    Row,
  } from 'reactstrap';
const FormItem=Form.Item;
const { Meta } = Card;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''

class SampleDetail extends React.Component{

    state={
        idtype: {},
        idtypeName:'' ,  
        idtypeDescription:'',
        priority: 'normal',
        datarequested:true,
        IDvaliditydays:0,

    }

    componentDidMount(){
        if(localStorage.getItem("token")){
          token= localStorage.getItem("token")
        }else{
          token= ''
        }

        axios.defaults.headers={
            "Content-Type":"application/json",
            Authorization:`Token ${token}`
          }

        const sampleID=this.props.match.params.sampleID;
        axios.get(`${serverconfig.backendserverurl}/api/samples/${sampleID}`)
        .then(res => {  
            this.setState({
                idtype: res.data

            })

            this.setState({idtypeName:res.data.name})
            this.setState({idtypeDescription:res.data.description})
            this.setState({priority: res.data.priority || 'normal'})
            this.setState({datarequested:false})

        })
    }

    handleIdTypeNameChange= (e) => this.setState({ idtypeName: e.target.value});
    handleIDDescriptionChange= (e) => this.setState({ idtypeDescription: e.target.value});
    handlePriorityChange= (value) => this.setState({ priority: value });
  

    //submit button pressed
  handleFormSubmit=() =>{
    this.setState({datarequested:true})

    const sampleID=this.props.match.params.sampleID;

    let form_data = new FormData();
    form_data.append('name', this.state.idtypeName);
    form_data.append('description', this.state.idtypeDescription);
    form_data.append('priority', this.state.priority);

    axios.put(`${serverconfig.backendserverurl}/api/samples/${sampleID}/`,form_data, {
        headers: {
        'content-type': 'multipart/form-data'
        }
    })
    .then(res =>this.setState({datarequested:false}),window.location.reload(false),message.info('Successfully updated '))
    .catch(error => console.log(error))


  }

    render(){

        if(this.state.datarequested===true){
            return(
              <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin indicator={antIcon} />
              </div>
            )
      
          }else{
            return(
                <div>
                    <Row>
                    <Col xs="12" sm="6" lg="4">
                    <Card title={this.state.idtype.name}>
                        <p>Description: {this.state.idtype.description}</p>
                        <p>Priority: <span style={{ 
                          color: this.getPriorityColor(this.state.idtype.priority),
                          fontWeight: 'bold',
                          textTransform: 'uppercase'
                        }}>{this.getPriorityLabel(this.state.idtype.priority)}</span></p>
                    </Card>
                    </Col>
                    <Col span={2}>
                 
                    </Col>
                    <Col xs="12" sm="6" lg="4">
                   
                    </Col>
    
                    </Row>
                    <br/>
    
                    <Row>
                    <Col xs="12" sm="6" lg="4">
                    <Card 
                    style={{padding:10}}
                    hoverable>
                        <h4>Sample Update</h4>
                        <Form>
                            <FormItem label="Name">
                            <Input name="idtypename"  placeholder="Put a name here." value={this.state.idtypeName} onChange={this.handleIdTypeNameChange} />
                            </FormItem>
                            <FormItem label="Description">
                            <Input name="description"  placeholder="Description here" value={this.state.idtypeDescription} onChange={this.handleIDDescriptionChange} />
                            </FormItem>
                            <FormItem label="Priority">
                            <Select 
                              placeholder="Select priority level" 
                              value={this.state.priority} 
                              onChange={this.handlePriorityChange}
                              size="large"
                            >
                              <Select.Option value="low">Low Priority</Select.Option>
                              <Select.Option value="normal">Normal Priority</Select.Option>
                              <Select.Option value="high">High Priority</Select.Option>
                              <Select.Option value="urgent">Urgent</Select.Option>
                              <Select.Option value="emergency">Emergency</Select.Option>
                            </Select>
                            </FormItem>
                        
                            <FormItem>
                            <Button onClick={(event) => this.handleFormSubmit()} type="primary" htmlType="button">Update</Button>
                            </FormItem>
                        </Form>
    
                    </Card>
    
                    </Col>
    
                  
                    </Row>
    
                    <br/>
    
                </div>
            )

          }
    }

  getPriorityColor(priority) {
    const priorityColors = {
      'low': '#52c41a',
      'normal': '#1890ff',
      'high': '#fa8c16',
      'urgent': '#f5222d',
      'emergency': '#722ed1'
    };
    return priorityColors[priority] || '#1890ff';
  }

  getPriorityLabel(priority) {
    const priorityLabels = {
      'low': 'Low',
      'normal': 'Normal',
      'high': 'High',
      'urgent': 'Urgent',
      'emergency': 'Emergency'
    };
    return priorityLabels[priority] || priority;
  }
}

export default SampleDetail; 